export default __webpack_public_path__ + "static/second-image-76a2e183028a39c9a78b9e613facc4f3.gif";